import Parse from 'parse'
import store from '../store'

function getAllRole() {
    return new Parse.Query(Parse.Role).find({useMasterKey: true}).then(roles => {
        store.commit('role/SET_ROLES', roles)
    });
}

function findRole() {

}

function addRole(editedItem) {
    let acl = new Parse.ACL();
    acl.setPublicWriteAccess(editedItem.write);
    acl.setPublicReadAccess(editedItem.read);
    let role = new Parse.Role(editedItem.roleName, acl);
    return role.save(null, {useMasterKey:true});
}

function editRole(editedItem) {
    console.log(editedItem);
    const acl = editedItem.role.getACL();
    acl.setPublicReadAccess(editedItem.read);
    acl.setPublicWriteAccess(editedItem.write);
    editedItem.role.setACL(acl, {});
    return editedItem.role.save(null,{useMasterKey:true});
}

export const ParseRoleService = {
    getAllRole,
    findRole,
    addRole,
    editRole
};
